import $ from 'jquery';

$('.catalog-detail-quantity__value').mask('000');

$('.catalog-detail-quantity__value').blur(function () {
    const val = $(this).val();
    if (val == '' || !val) {
        $(this).val('1');
    }
});

$('.catalog-detail-quantity__control--minus').click(function () {
    let val = +$('.catalog-detail-quantity__value').val() - 1;
    if (val < 1) {
        val = 1;
    }
    $('.catalog-detail-quantity__value').val(val);
});

$('.catalog-detail-quantity__control--plus').click(function () {
    let val = +$('.catalog-detail-quantity__value').val() + 1;
    if (val > 999) {
        val = 999;
    }
    $('.catalog-detail-quantity__value').val(val);
});
